module.exports = __webpack_public_path__ + "static/media/tmpru.7c5bfb51.png";